import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectors as apiSelectors } from 'zender-api-client';

import NextStream from './NextStream.component';
import * as appSelectors from '../../../../../selectors';

const NextStreamContainer = props => <NextStream {...props} />;

const mapStateToProps = state => ({
	nextStream: apiSelectors.channel.nextStreamSelector(state),
	locale: appSelectors.locale.localeSelector(state),
});

const mapDispatchToProps = () => ({});

NextStreamContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NextStreamContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/nextStream/NextStream.container.js